module.exports = __webpack_public_path__ + "static/media/check-box.3c668b20.svg";